// 获取模块主要获取数据模块
import request from '@/utils/request';
// 获取数据
export const getLevel = () => request({url: '/look/star/getStarSettingInfo', method: 'get'});